import type { WShopPromotionalProductsTranslations } from "./pl";

export const en: WShopPromotionalProductsTranslations = {
  title: "Special offers",
  showAll: "See all",
  noProducts: "No products on sale.",
};
